import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as Loading } from '../../images/loading.svg';

export const LoadingIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={Loading} />
);

export default LoadingIcon;
